import { render, staticRenderFns } from "./addDetails.vue?vue&type=template&id=50d65f76&scoped=true&"
import script from "./addDetails.vue?vue&type=script&lang=js&"
export * from "./addDetails.vue?vue&type=script&lang=js&"
import style0 from "./addDetails.vue?vue&type=style&index=0&id=50d65f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d65f76",
  null
  
)

export default component.exports